import {
    combineReducers,
} from 'redux';

// import familyReducer from './family.reducer';
// import selectionReducer from './selection.reducuer';
import configReducer from './config.reducer';
import coveragesReducer from './coverages.reducer';

const appReducer = combineReducers({
    sample: () => null,
    config: configReducer,
    coverages: coveragesReducer,
});

const rootReducer = (state, action) => {
    // if (action.type === USER_LOGOUT) {
    //     state = undefined;
    // }
    return appReducer(state, action);
};

export default rootReducer;
